export default "<p>list-partners-products-buy works!</p>\n"